var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"link-button",attrs:{"href":_vm.href,"text":"","target":"_blank","ripple":false,"plain":"","data-tooltip":_vm.tooltipText}},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('v-icon',[_vm._v("mdi-open-in-new")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }